<template>
    <v-dialog v-model="showDialog" max-width="600px" persistent>
        <v-sheet class="dialog" rounded>
            <div class="dialog-header">{{
                    $t("global.delete_confirmation")
                }}
            </div>
            <div class="dialog-content">
                {{ message }}
            </div>
            <div class="dialog-footer d-flex">
                <v-btn elevation="0"
                       @click="showDialog = false">
                    {{ $t("global.cancel") }}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn color="primary" elevation="0"
                       @click="$emit('validate')">
                    {{ $t("global.validate") }}
                </v-btn>
            </div>
        </v-sheet>
    </v-dialog>
</template>

<script>
import i18n from "../../plugins/i18n";

export default {
    name: "ConfirmDelete",
    props: {
        visible: {
            type: Boolean,
            required: true,
            default: false,
        },
        message: {
            type: String,
            required: false,
            default: function () {
                return i18n.t("global.going_to_delete")
            }
        }
    },
    computed: {
        showDialog: {
            get() {
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },
}
</script>
